import isDeliveredNationalwide from '../../utils/tags/isDeliveredNationalwide';

export const DeliveryPlace = ({ tags }) =>
  isDeliveredNationalwide(tags) && (
    <div className="row">
      <div className="col-12 mt-3">
        <p className="text-secondary">
          <i className="fas fa-check" aria-hidden="true" /> Entrega para todo o
          Brasil
        </p>
      </div>
    </div>
  );
